import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7b31a41c = () => interopDefault(import('../pages/a-good-company.vue' /* webpackChunkName: "pages/a-good-company" */))
const _438628ca = () => interopDefault(import('../pages/anker/index.vue' /* webpackChunkName: "pages/anker/index" */))
const _5327f727 = () => interopDefault(import('../pages/apple-iphone-17-zubehoer.vue' /* webpackChunkName: "pages/apple-iphone-17-zubehoer" */))
const _aaac2d02 = () => interopDefault(import('../pages/google/index.vue' /* webpackChunkName: "pages/google/index" */))
const _0467296c = () => interopDefault(import('../pages/handyrechnung-aktion.vue' /* webpackChunkName: "pages/handyrechnung-aktion" */))
const _c1669daa = () => interopDefault(import('../pages/infos-zum-online-kauf.vue' /* webpackChunkName: "pages/infos-zum-online-kauf" */))
const _b2b0d926 = () => interopDefault(import('../pages/kontakt.vue' /* webpackChunkName: "pages/kontakt" */))
const _61327360 = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _8e608f3a = () => interopDefault(import('../pages/merkliste.vue' /* webpackChunkName: "pages/merkliste" */))
const _2b0fe8fc = () => interopDefault(import('../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _11a8e4c2 = () => interopDefault(import('../pages/panzerglass.vue' /* webpackChunkName: "pages/panzerglass" */))
const _d38d952a = () => interopDefault(import('../pages/preisvorteile-sichern.vue' /* webpackChunkName: "pages/preisvorteile-sichern" */))
const _8edde6ec = () => interopDefault(import('../pages/samsung/index.vue' /* webpackChunkName: "pages/samsung/index" */))
const _60b0d922 = () => interopDefault(import('../pages/sicherheit-und-einbruchschutz.vue' /* webpackChunkName: "pages/sicherheit-und-einbruchschutz" */))
const _07231354 = () => interopDefault(import('../pages/smart-home-entdecken.vue' /* webpackChunkName: "pages/smart-home-entdecken" */))
const _8e4a7bcc = () => interopDefault(import('../pages/smarte-gemuetlichkeit.vue' /* webpackChunkName: "pages/smarte-gemuetlichkeit" */))
const _4fef9d3b = () => interopDefault(import('../pages/soundcore.vue' /* webpackChunkName: "pages/soundcore" */))
const _3d3053f0 = () => interopDefault(import('../pages/stabiles-internet.vue' /* webpackChunkName: "pages/stabiles-internet" */))
const _5653d407 = () => interopDefault(import('../pages/themenwelten.vue' /* webpackChunkName: "pages/themenwelten" */))
const _e0f25504 = () => interopDefault(import('../pages/xiaomi.vue' /* webpackChunkName: "pages/xiaomi" */))
const _bf643d02 = () => interopDefault(import('../pages/xiaomi-smartphones.vue' /* webpackChunkName: "pages/xiaomi-smartphones" */))
const _f22be85e = () => interopDefault(import('../pages/xiaomi-zubehoer.vue' /* webpackChunkName: "pages/xiaomi-zubehoer" */))
const _b8d0f196 = () => interopDefault(import('../pages/zahlung-per-handyrechnung.vue' /* webpackChunkName: "pages/zahlung-per-handyrechnung" */))
const _7d753654 = () => interopDefault(import('../pages/anker/product-data.ts' /* webpackChunkName: "pages/anker/product-data" */))
const _324d6684 = () => interopDefault(import('../pages/google/product-data.js' /* webpackChunkName: "pages/google/product-data" */))
const _ba0ea520 = () => interopDefault(import('../pages/hilfe/lieferstatus-und-retoure.vue' /* webpackChunkName: "pages/hilfe/lieferstatus-und-retoure" */))
const _921a52f6 = () => interopDefault(import('../pages/samsung/product-data.ts' /* webpackChunkName: "pages/samsung/product-data" */))
const _11fa87ac = () => interopDefault(import('../pages/shop/bestaetigung.vue' /* webpackChunkName: "pages/shop/bestaetigung" */))
const _0996101b = () => interopDefault(import('../pages/shop/brodos-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/brodos-zahlungsverifizierung" */))
const _5d96e876 = () => interopDefault(import('../pages/shop/fehler.vue' /* webpackChunkName: "pages/shop/fehler" */))
const _7dc4fad0 = () => interopDefault(import('../pages/shop/telekom-bestaetigung.vue' /* webpackChunkName: "pages/shop/telekom-bestaetigung" */))
const _6f3d6a9b = () => interopDefault(import('../pages/shop/telekom-bezahlung-information.vue' /* webpackChunkName: "pages/shop/telekom-bezahlung-information" */))
const _1cb05f56 = () => interopDefault(import('../pages/shop/telekom-zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/telekom-zahlungsverifizierung" */))
const _86244de2 = () => interopDefault(import('../pages/shop/warenkorb.vue' /* webpackChunkName: "pages/shop/warenkorb" */))
const _39753b03 = () => interopDefault(import('../pages/shop/zahlungsverifizierung.vue' /* webpackChunkName: "pages/shop/zahlungsverifizierung" */))
const _39b2906a = () => interopDefault(import('../pages/shop/zusammenfassung.vue' /* webpackChunkName: "pages/shop/zusammenfassung" */))
const _39abe985 = () => interopDefault(import('../pages/weitere-informationen/agb-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/agb-brodos" */))
const _6e0fda7a = () => interopDefault(import('../pages/weitere-informationen/sitemap.vue' /* webpackChunkName: "pages/weitere-informationen/sitemap" */))
const _0d67643c = () => interopDefault(import('../pages/weitere-informationen/ueber-brodos.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-brodos" */))
const _2bca4de4 = () => interopDefault(import('../pages/weitere-informationen/ueber-qivicon.vue' /* webpackChunkName: "pages/weitere-informationen/ueber-qivicon" */))
const _a8a66d10 = () => interopDefault(import('../pages/shop/kundenformular/persoenliche-daten.vue' /* webpackChunkName: "pages/shop/kundenformular/persoenliche-daten" */))
const _d1d5fb82 = () => interopDefault(import('../pages/shop/kundenformular/zahlungsart.vue' /* webpackChunkName: "pages/shop/kundenformular/zahlungsart" */))
const _1bb47d5f = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f4e4b032 = () => interopDefault(import('../special-pages/product-details.vue' /* webpackChunkName: "" */))
const _ffccdd50 = () => interopDefault(import('../special-pages/shop-list.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/a-good-company",
    component: _7b31a41c,
    name: "a-good-company"
  }, {
    path: "/anker",
    component: _438628ca,
    name: "anker"
  }, {
    path: "/apple-iphone-17-zubehoer",
    component: _5327f727,
    name: "apple-iphone-17-zubehoer"
  }, {
    path: "/google",
    component: _aaac2d02,
    name: "google"
  }, {
    path: "/handyrechnung-aktion",
    component: _0467296c,
    name: "handyrechnung-aktion"
  }, {
    path: "/infos-zum-online-kauf",
    component: _c1669daa,
    name: "infos-zum-online-kauf"
  }, {
    path: "/kontakt",
    component: _b2b0d926,
    name: "kontakt"
  }, {
    path: "/maintenance",
    component: _61327360,
    name: "maintenance"
  }, {
    path: "/merkliste",
    component: _8e608f3a,
    name: "merkliste"
  }, {
    path: "/newsletter",
    component: _2b0fe8fc,
    name: "newsletter"
  }, {
    path: "/panzerglass",
    component: _11a8e4c2,
    name: "panzerglass"
  }, {
    path: "/preisvorteile-sichern",
    component: _d38d952a,
    name: "preisvorteile-sichern"
  }, {
    path: "/samsung",
    component: _8edde6ec,
    name: "samsung"
  }, {
    path: "/sicherheit-und-einbruchschutz",
    component: _60b0d922,
    name: "sicherheit-und-einbruchschutz"
  }, {
    path: "/smart-home-entdecken",
    component: _07231354,
    name: "smart-home-entdecken"
  }, {
    path: "/smarte-gemuetlichkeit",
    component: _8e4a7bcc,
    name: "smarte-gemuetlichkeit"
  }, {
    path: "/soundcore",
    component: _4fef9d3b,
    name: "soundcore"
  }, {
    path: "/stabiles-internet",
    component: _3d3053f0,
    name: "stabiles-internet"
  }, {
    path: "/themenwelten",
    component: _5653d407,
    name: "themenwelten"
  }, {
    path: "/xiaomi",
    component: _e0f25504,
    name: "xiaomi"
  }, {
    path: "/xiaomi-smartphones",
    component: _bf643d02,
    name: "xiaomi-smartphones"
  }, {
    path: "/xiaomi-zubehoer",
    component: _f22be85e,
    name: "xiaomi-zubehoer"
  }, {
    path: "/zahlung-per-handyrechnung",
    component: _b8d0f196,
    name: "zahlung-per-handyrechnung"
  }, {
    path: "/anker/product-data",
    component: _7d753654,
    name: "anker-product-data"
  }, {
    path: "/google/product-data",
    component: _324d6684,
    name: "google-product-data"
  }, {
    path: "/hilfe/lieferstatus-und-retoure",
    component: _ba0ea520,
    name: "hilfe-lieferstatus-und-retoure"
  }, {
    path: "/samsung/product-data",
    component: _921a52f6,
    name: "samsung-product-data"
  }, {
    path: "/shop/bestaetigung",
    component: _11fa87ac,
    name: "shop-bestaetigung"
  }, {
    path: "/shop/brodos-zahlungsverifizierung",
    component: _0996101b,
    name: "shop-brodos-zahlungsverifizierung"
  }, {
    path: "/shop/fehler",
    component: _5d96e876,
    name: "shop-fehler"
  }, {
    path: "/shop/telekom-bestaetigung",
    component: _7dc4fad0,
    name: "shop-telekom-bestaetigung"
  }, {
    path: "/shop/telekom-bezahlung-information",
    component: _6f3d6a9b,
    name: "shop-telekom-bezahlung-information"
  }, {
    path: "/shop/telekom-zahlungsverifizierung",
    component: _1cb05f56,
    name: "shop-telekom-zahlungsverifizierung"
  }, {
    path: "/shop/warenkorb",
    component: _86244de2,
    name: "shop-warenkorb"
  }, {
    path: "/shop/zahlungsverifizierung",
    component: _39753b03,
    name: "shop-zahlungsverifizierung"
  }, {
    path: "/shop/zusammenfassung",
    component: _39b2906a,
    name: "shop-zusammenfassung"
  }, {
    path: "/weitere-informationen/agb-brodos",
    component: _39abe985,
    name: "weitere-informationen-agb-brodos"
  }, {
    path: "/weitere-informationen/sitemap",
    component: _6e0fda7a,
    name: "weitere-informationen-sitemap"
  }, {
    path: "/weitere-informationen/ueber-brodos",
    component: _0d67643c,
    name: "weitere-informationen-ueber-brodos"
  }, {
    path: "/weitere-informationen/ueber-qivicon",
    component: _2bca4de4,
    name: "weitere-informationen-ueber-qivicon"
  }, {
    path: "/shop/kundenformular/persoenliche-daten",
    component: _a8a66d10,
    name: "shop-kundenformular-persoenliche-daten"
  }, {
    path: "/shop/kundenformular/zahlungsart",
    component: _d1d5fb82,
    name: "shop-kundenformular-zahlungsart"
  }, {
    path: "/",
    component: _1bb47d5f,
    name: "index"
  }, {
    path: "/geraete/:slug?",
    component: _f4e4b032,
    name: "ProductDetails"
  }, {
    path: "/:config+",
    component: _ffccdd50,
    name: "ShopList"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
